module.exports = __webpack_public_path__ + "img/10@2x.dd092646.png";